/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  TelegramUsersControllerDeleteMutationResponse,
  TelegramUsersControllerDelete401,
} from '../../types/TelegramUsersControllerDelete.ts';
import type { UseMutationOptions, QueryClient } from '@tanstack/react-query';
import { telegramUsersDelete } from '../../methods/telegramUsersDelete.ts';
import { useMutation } from '@tanstack/react-query';

export const telegramUsersDeleteMutationKey = () => [{ url: '/api/telegram/users' }] as const;

export type TelegramUsersDeleteMutationKey = ReturnType<typeof telegramUsersDeleteMutationKey>;

/**
 * {@link /api/telegram/users}
 */
export function useTelegramUsersDelete<TContext>(
  options: {
    mutation?: UseMutationOptions<
      TelegramUsersControllerDeleteMutationResponse,
      ResponseErrorConfig<TelegramUsersControllerDelete401>,
      void,
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? telegramUsersDeleteMutationKey();

  return useMutation<
    TelegramUsersControllerDeleteMutationResponse,
    ResponseErrorConfig<TelegramUsersControllerDelete401>,
    void,
    TContext
  >(
    {
      mutationFn: async () => {
        return telegramUsersDelete(config);
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  );
}
